import Vue from 'vue'
import Router from 'vue-router'

import Store, {store} from '../store/store'


import Start from '@/components/Start'
import User from '@/components/user/User'
import Menu from '@/components/menu/Menu'
import Role from '@/components/role/Role'
import Login from '@/components/login/Login'
import Company from '@/components/company/Company'
import Proessat from '@/components/company/guiaProessat/GuiaProessat'
import Catalog from '@/components/catalog/Catalog'
import Provider from '@/components/provider/Provider'
import UserReport from '@/components/reports/UserReport'
import Parameter from '@/components/parameter/Parameter'
import ChangePassword from '@/components/ChangePassword'
import LaboratoryExam from '@/components/laboratoryExam/LaboratoryExam'
import Vaccine from '@/components/vaccine/Vaccine'
import Procedure from '@/components/procedure/Procedure'
import Type from '@/components/type/Type'
import Patient from '@/components/patient/Patient'
import PatientHojaDeRutaNew from '@/components/patient/hojaDeRuta/HojaDeRuta'
import PatientProcess from '@/components/patient/process/Process'
import CovidList from '@/components/covid/Covid'
import CovidRegister from '@/components/covid/CovidRegister'
import CovidTracer from '@/components/covid/CovidTracer'
import CovidTracerResponse from '@/components/covid/CovidTracerResponse'
import CovidTracerMap from '@/components/covid/CovidTracerMap'
import CovidPatient from '@/components/covid/CovidPatient'
import CovidIndex from '@/components/covid/CovidIndex'
import CovidPatientAlarm from '@/components/covid/CovidPatientAlarm'
import CovidPatientEvolution from '@/components/covid/CovidPatientEvolution'
import CovidAlarmRegister from '@/components/covid/CovidAlarmRegister'
import CovidConfiguration from '@/components/covid/CovidConfiguration'
import ExportProcess from '@/components/exportProcess/ExportProcess'
import ExportProcessList from '@/components/exportProcess/ExportProcessList'
import AptitudeWork from '@/components/covid/AptitudeWork'
import Audit from '@/components/audit/Audit'
import MatrizRiegoGrupoHomogenioReport from '@/components/reports/MatrizRiesgoGrupoHomogenioReport'
import VaccinesReport from '@/components/reports/VaccinesReport'
import AlertsReport from '@/components/reports/AlertsReport'
import ActivityConfiguration from '@/components/activity/ActivityConfiguration'
import ActivityConfigurationCompany from '@/components/activity/ActivityConfigurationCompany'
import ActivityExportProcess from '@/components/activity/ActivityExportProcess'
import Activity from '@/components/activity/Activity'
import ActivityList from '@/components/activity/ActivityList'
import OpenedPatientRouteSheets from '@/components/reports/OpenedPatientRouteSheets'
import ActivityCompany from '@/components/activityCompany/ActivityCompany'
import ActivityFile from '@/components/activity/ActivityFile'
import ActivityCompanyPeriod from '@/components/activityCompany/ActivityCompanyPeriod'




Vue.use(Router)

export default new Router({
  routes: [
    {path: '/changePassword', component: ChangePassword, name: 'ChangePassword'},
    {path: '/', component: Login},
    {path: '/login', component: Login, name: 'Login'},
    {
      path: '/start',
      name: 'start',
      component: Start,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/company',
      name: 'company',
      component: Company,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/role',
      name: 'role',
      component: Role,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/catalog',
      name: 'catalog',
      component: Catalog,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/parameter',
      name: 'parameter',
      component: Parameter,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/patient',
      name: 'patient',
      component: Patient,
      beforeEnter(to,from,next){            
        if (from.name !== 'auditOHS' && from.name !== 'reporteHojasAbiertas' ) {          
          store.state.buscadorPaciente = null;
        }        
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/user',
      name: 'user',
      component: User,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/userReport',
      name: 'userReport',
      component: UserReport,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/menu',
      name: 'menu',
      component: Menu,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/provider',
      name: 'provider',
      component: Provider,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/laboratoryExam',
      name: 'laboratoryExam',
      component: LaboratoryExam,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/vaccine',
      name: 'vaccine',
      component: Vaccine,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/procedure',
      name: 'procedure',
      component: Procedure,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/type',
      name: 'type',
      component: Type,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/patientHojaRuta',
      name: 'patientHojaRuta',
      component: PatientHojaDeRutaNew,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/process',
      name: 'process',
      component: PatientProcess,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/covidRegister',
      name: 'covidRegister',
      component: CovidRegister
    },
    {
      path: '/covidAlarmRegister',
      name: 'covidAlarmRegister',
      component: CovidAlarmRegister
    },
    {
      path: '/covid',
      name: 'covid',
      component: CovidList,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/covidTracer',
      name: 'covidTracer',
      component: CovidTracer,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/covidTracerResponse',
      name: 'covidTracerResponse',
      component: CovidTracerResponse
    },
    {
      path: '/covidIndex',
      name: 'covidIndex',
      component: CovidIndex
    },
    {
      path: '/covidTracerMap',
      name: 'covidTracerMap',
      component: CovidTracerMap,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/covidPatient',
      name: 'covidPatient',
      component: CovidPatient,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/covidPatientAlarm',
      name: 'covidPatientAlarm',
      component: CovidPatientAlarm,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/covidPatientEvolution',
      name: 'covidPatientEvolution',
      component: CovidPatientEvolution,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/covidConfiguration',
      name: 'covidConfiguration',
      component: CovidConfiguration,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/exportProcess',
      name: 'exportProcess',
      component: ExportProcess,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/exportProcessList',
      name: 'exportProcessList',
      component: ExportProcessList,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/aptitudeWork',
      name: 'aptitudeWork',
      component: AptitudeWork,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/auditOHS',
      name: 'auditOHS',
      component: Audit,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/matrizRiegoGrupoHomogenioReport',
      name: 'matrizRiegoGrupoHomogenioReport',
      component: MatrizRiegoGrupoHomogenioReport,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/reporteVacunas',
      name: 'reporteVacunas',
      component: VaccinesReport,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/reporteAlertas',
      name: 'reporteAlertas',
      component: AlertsReport,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/proessat',
      name: 'proessat',
      component: Proessat,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/reporteHojasAbiertas',
      name: 'reporteHojasAbiertas',
      component: OpenedPatientRouteSheets,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/activityConfiguration',
      name: 'activityConfiguration',
      component: ActivityConfiguration,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/activity',
      name: 'activity',
      component: Activity,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/activityList',
      name: 'activityList',
      component: ActivityList,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/activity-company',
      name: 'activity-company',
      component: ActivityCompany,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/activityConfigurationCompany',
      name: 'activityConfigurationCompany',
      component: ActivityConfigurationCompany,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/activityExportProcess',
      name: 'activityExportProcess',
      component: ActivityExportProcess,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/activityFile',
      name: 'activityFile',
      component: ActivityFile,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/activityCompanyPeriod',
      name: 'activityCompanyPeriod',
      component: ActivityCompanyPeriod,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js